<template>
    <div class="layout__position-left layout__width-100">

        <div class="layout__search-field__insights-250px">
            <p class="layout__margin__bottom-10 text__align-left">Report Level</p>
            <el-form ref="customer">
                <el-form-item prop="search">
                    <el-select v-model="searchParams.reportLevel" placeholder="Select" @change="handleReportLevelSelect">
                        <el-option v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

    </div>

</template>

<style>
    canvas {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    #chartjs-tooltip {
        opacity: 1;
        position: absolute;
        background: rgba(0, 0, 0, .7);
        color: white;
        border-radius: 3px;
        -webkit-transition: all .1s ease;
        transition: all .1s ease;
        pointer-events: none;
        -webkit-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        text-align: center;
    }
    .chartjs-tooltip-key {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 10px;
    }
    .chartjs-data {
        display: none;
    }
</style>

<script>

    import Chart from 'chart.heatmap.js';
    import Axios from 'axios';
    import moment from 'moment';
    import download from 'downloadjs';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import chartHeatmapBase from '../../mixins/chart-heatmap-base.js';

    export default {
        name: "customerHeatmapSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                downloadUrl: '',
                myChart: Object,
                options: [{
                    value: 'Company',
                    label: 'Company'
                }, {
                    value: 'Brand',
                    label: 'Brand'
                }, {
                    value: 'Branch',
                    label: 'Branch'
                }],
                value: 'Company'
            }
        },
        created() {
            console.log('CREATED');
            const date = new Date();
            date.setDate(date.getDate() - 7);
            console.log('created date');

            this.value = this.options[0];
            this.searchParams.salesToDate = moment().subtract(1, 'months');
            this.searchParams.salesFromDate = moment().subtract(11, 'months');
            this.searchParams.reportLevel = 'Company';
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED');
            this.searchParams.salesToDate = moment().subtract(1, 'months');
            this.searchParams.salesFromDate = moment().subtract(11, 'months');
            this.searchParams.reportLevel = 'Company';
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {
                console.log('before')
                console.log(this.searchParams)

                let searchTerms = Object.assign({}, this.searchParams)
                console.log('searchTerms')
                console.log(searchTerms)

                if (searchTerms.salesFromDate !== null && searchTerms.salesFromDate.length !== undefined) {
                    if (searchTerms.salesFromDate.toString().includes('/')) {
                        searchTerms.salesFromDate = this.convertDate(searchTerms.salesFromDate)
                    }
                }

                if (searchTerms.salesToDate !== null && searchTerms.salesToDate.length !== undefined) {
                    if (searchTerms.salesToDate.toString().includes('/')) {
                        searchTerms.salesToDate = this.convertDate(searchTerms.salesToDate)
                    }
                }

                console.log('after search is copied')
                console.log(this.searchParams)

                console.log('after search is copied - new object')
                console.log(searchTerms)

                var startDate = moment(searchTerms.salesFromDate).format('YYYY%2FMM%2FDD'),
                    endDate = moment(searchTerms.salesToDate).format('YYYY%2FMM%2FDD'),
                    colourBoundaries = '50,100,200,300'.replace(/,/g, '%2C'),
                    reportLevel = searchTerms.reportLevel,
                    endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetCustomerHeatmap?startDate=' + startDate + '&endDate=' + endDate + '&colourBoundaries=' + colourBoundaries + '&reportLevel=' + reportLevel;

                console.log(endpoint)

                this.$parent.loading = true;

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    var lookup = {},
                        result = [],
                        custNo = 0,
                        orderDate,
                        orders = response.data.customerHeatmap;

                    var tc1 = document.getElementsByClassName("cell");
                    tc1[0].innerHTML = tc1[0].innerHTML.replace('Ref', searchTerms.reportLevel);
                    tc1[0].innerHTML = tc1[0].innerHTML.replace('Company', searchTerms.reportLevel);
                    tc1[0].innerHTML = tc1[0].innerHTML.replace('Brand', searchTerms.reportLevel);
                    tc1[0].innerHTML = tc1[0].innerHTML.replace('Branch', searchTerms.reportLevel);

                    this.$parent.sales = orders;

                    var chartId = 'heatmap',
                        chartData = chartHeatmapBase;

                    chartData['data'].labels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
                    chartData['data'].datasets = [];

                    chartData['data'].datasets.push({});
                    chartData['data'].datasets[0] = {"label":"1-10", "data":[]};
                    chartData['data'].datasets[1] = {"label":"11-20", "data":[]};
                    chartData['data'].datasets[2] = {"label":"21-30", "data":[]};
                    chartData['data'].datasets[3] = {"label":"31-40", "data":[]};
                    chartData['data'].datasets[4] = {"label":"41-50", "data":[]};
                    chartData['data'].datasets[5] = {"label":"51-60", "data":[]};
                    chartData['data'].datasets[6] = {"label":"61-70", "data":[]};
                    chartData['data'].datasets[7] = {"label":"71-80", "data":[]};
                    chartData['data'].datasets[8] = {"label":"81-90", "data":[]};
                    chartData['data'].datasets[9] = {"label":"91-100", "data":[]};

                    for (var order, i = 0; order = orders[i++];) {
                        if (i > 0 && i <= 10) {
                            chartData['data'].datasets[0].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-1-10', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 10 && i <= 20) {
                            chartData['data'].datasets[1].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-11-20', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 20 && i <= 30) {
                            chartData['data'].datasets[2].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-21-30', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 30 && i <= 40) {
                            chartData['data'].datasets[3].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-31-40', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 40 && i <= 50) {
                            chartData['data'].datasets[4].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-41-50', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 50 && i <= 60) {
                            chartData['data'].datasets[5].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-51-60', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 60 && i <= 70) {
                            chartData['data'].datasets[6].data.push(order.colourscale.toString());
                            this. addValueToDiv('chartjs-data-61-70', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 70 && i <= 80) {
                            chartData['data'].datasets[7].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-71-80', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 80 && i <= 90) {
                            chartData['data'].datasets[8].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-81-90', order.ref.toString() + '<br>' + order.variance.toString());
                        } else if (i > 90 && i <= 100) {
                            chartData['data'].datasets[9].data.push(order.colourscale.toString());
                            this.addValueToDiv('chartjs-data-91-100', order.ref.toString() + '<br>' + order.variance.toString());
                        }
                    }

                    var customTooltips = function (tooltip) {
                        var tooltipEl = document.getElementById('chartjs-tooltip');
                        
                        if (!tooltip) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }
                        
                        // split out the label and value and make your own tooltip here
                        var parts = tooltip.text.split(' | '),
                            column = parts[0].trim(),
                            row = parts[1].trim(),
                            tooltipData = document.getElementById('chartjs-data-' + row).innerHTML,
                            tooltipDataParts = tooltipData.split(',');

                        var innerHtml = '<span><b>' + tooltipDataParts[column - 1] + '</b></span>';
                        tooltipEl.innerHTML = innerHtml;

                        var positionY = tooltip.chart.canvas.offsetTop;
                        var positionX = tooltip.chart.canvas.offsetLeft;

                        tooltipEl.style.opacity = 1;
                        // add 50 to ensure the tooltip is not clipped on the left
                        tooltipEl.style.left = positionX + tooltip.x + 50 + 'px';
                        tooltipEl.style.top = positionY + tooltip.y + 'px';
                        tooltipEl.style.fontSize = '12px';
                        tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
                    };

                    chartData['options'].customTooltips = customTooltips;

                    var ctx = document.getElementById(chartId).getContext('2d');
                    this.myChart = new Chart(ctx).HeatMap(chartData.data, chartData.options);

                    var chart = document.getElementById('heatmap'),
                        chartWidthStep = (parseInt(chart.style.width.replace('px','')) / 10) - 6,
                        chartHeightStep = (parseInt(chart.style.height.replace('px','')) / 10) - 3.5;

                    console.log(chartWidthStep);
                    console.log(chartHeightStep);

                    for (var order, i = 0; order = orders[i++];) {
                        var left = chart.offsetLeft + chartWidthStep,
                            top = chart.offsetTop + chartHeightStep;
                        
                        if (i > 0 && i <= 10) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 1));
                            top = chart.offsetTop;
                        } else if (i > 10 && i <= 20) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 11));
                            top = chart.offsetTop + chartHeightStep;
                        } else if (i > 20 && i <= 30) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 21));
                            top = chart.offsetTop + (chartHeightStep * 2);
                        } else if (i > 30 && i <= 40) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 31));
                            top = chart.offsetTop + (chartHeightStep * 3);
                        } else if (i > 40 && i <= 50) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 41));
                            top = chart.offsetTop + (chartHeightStep * 4);
                        } else if (i > 50 && i <= 60) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 51));
                            top = chart.offsetTop + (chartHeightStep * 5);
                        } else if (i > 60 && i <= 70) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 61));
                            top = chart.offsetTop + (chartHeightStep * 6);
                        } else if (i > 70 && i <= 80) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 71));
                            top = chart.offsetTop + (chartHeightStep * 7);
                        } else if (i > 80 && i <= 90) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 81));
                            top = chart.offsetTop + (chartHeightStep * 8);
                        } else if (i > 90 && i <= 100) {
                            left = chart.offsetLeft + (chartWidthStep * (i - 91));
                            top = chart.offsetTop + (chartHeightStep * 9);
                        }

                        this.createNewDiv('chartjs-data-' + i.toString(), order.ref.toString() + '<br>' + order.variance.toString() + '%', left, top, chartWidthStep);
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$parent.loading = false;
                    });
                })
            },
            handleReportLevelSelect(val) {
                console.log('handleReportLevelSelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.getSales('searchParams');
            },
            addValueToDiv(id, val) {
                var toolkitData = document.getElementById(id).innerHTML
                if (toolkitData.length > 0) {
                    toolkitData += ',';
                }
                toolkitData += val + '%';

                document.getElementById(id).innerHTML = toolkitData;
            },
            createNewDiv(id, val, left, top, width) {
                if (document.contains(document.getElementById(id))) {
                    document.getElementById(id).remove();
                }

                var body = document.getElementsByTagName('body')[0],
                    chart = document.getElementById('heatmap'),
                    newdiv = document.createElement('div');

                newdiv.id = id;
                newdiv.innerHTML = val;
                newdiv.className = 'chartjs-data-single';
                newdiv.onmouseover = function() {
                    var tooltipEl = document.getElementById('chartjs-tooltip');

                    tooltipEl.innerHTML = '<b>' + val + '</b>';
                    tooltipEl.style.opacity = 1;
                    // add 50 to ensure the tooltip is not clipped on the left
                    tooltipEl.style.left = left + 152 + 'px';
                    tooltipEl.style.top = top + 28 + 'px';
                    tooltipEl.style.fontSize = '12px';
                };

                chart.parentNode.insertBefore(newdiv, chart.nextSibling);
                newdiv.setAttribute('style', 'position: absolute; font-size: 12px; color: white; width: ' + width.toString() + 'px; text-align: center;'); 
                newdiv.style.top = top + 28 + 'px'; 
                newdiv.style.left = left + 52 + 'px'; 
            },
            csv() {
                var level = document.getElementsByClassName("el-table_1_column_1")[0].innerText;

                const fields = [
                    {label: level, value: 'ref'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Average Spend', value: 'average_Spend'},
                    {label: 'Spend (Last 30 Days)', value: 'spend_Last_30_Days'},
                    {label: 'Variance', value: 'variance'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            }
        }
    };
</script>